import { Box, Grid } from "@mui/material";
import { ITest, RHookFormNumberField } from "@websential/cosmic-v20";

import { FC } from "react";

interface ICompleteAccordingToChartSetupFieldsPanel {
  fields53For15c:any
}
export const CompleteAccordingToChartSetupFieldsPanel: FC<
  ICompleteAccordingToChartSetupFieldsPanel
> = ({fields53For15c}) => {
  // let data = [
  // 	{
  // 		id:1,
  // 		value:123
  // 	},
  // 	{
  // 		id:2,
  // 		value:1234
  // 	},
  // 	{
  // 		id:3,
  // 		value:12345
  // 	},
  // 	{
  // 		id:4,
  // 		value:123456
  // 	},
  // ]

  // [123,4564,789]
  // let data = Array.from({ length: 53 }, (_, i) => ({
  //   id: i + 1,
  //   value: (i + 1) * 111, // gives unique values for each
  // }));
  return (
    <>

      <Grid container size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
        {fields53For15c.map((item:any) => (
          <Grid
            key={item.id}
            container
            size={{ xs: 3.75, sm: 3.75, md: 3.75, lg: 3.75, xl: 3.75 }}
            sx={{ display: "flex" }}
          >
            <Grid
              size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
              sx={{ display: "contents" }}
            >
              <Grid size={{ xs: 3, sm: 3, md: 3, lg: 3, xl: 3 }} />
              <Grid
                size={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }}
                sx={{ paddingTop: "7px", textAlign: "center" }}
              >
                {item.id}
              </Grid>
              <Grid size={{ xs: 8, sm: 8, md: 8, lg: 8, xl: 8 }}>
                <RHookFormNumberField
                  id={`${item.id}`}
                  testId={`${item.id}`}
                  // value={item.value}
                  defaultValue={item.value}
                />
              </Grid>
            </Grid>
          </Grid>
        ))}
      </Grid>
    </>
  );
};
